// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import PastDueOrdersTable from './components/past-due-orders-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    getPastDueOrders
} from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class PastDueOrders extends Component {

    state = {

        results: []
    };

    componentDidMount = () => {

        this.refresh();

    }

    refresh () {

        this.props.increaseCounter();
        getPastDueOrders()
            .then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            results
        } = this.state;

        const additionalInfo = ( results !== null ? {
            unitName: this.props.unit.name
        } : '' );
        const pastDueOrdersResult = results.map( i => ( { ...i, ...additionalInfo } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Past Due Orders</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-order-availability-top-options">
                            <div className="select-options" />
                        </div>

                        <PastDueOrdersTable
                            results={pastDueOrdersResult}
                        />
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

PastDueOrders.displayName = 'PastDueOrders';
PastDueOrders.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( PastDueOrders ) );
